import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import ServiceListFilterSection from 'components/configured-service/CreateDraftConfiguredServiceDialog/ServiceListFilterSection'
import { useCreateDraftConfiguredServiceContext } from '../CreateDraftConfiguredServiceContext'

const DraftServiceFilterSidebar = ({ onToggle: onToggleOverride, disableOutline = false }) => {
  const { onFilterChange, control, pricingServices, handleToggleFilterPanel } = useCreateDraftConfiguredServiceContext()

  return (
    <Box sx={{ height: '100%', width: '100%', overflow: 'hidden', pl: 1.5 }}>
      <ServiceListFilterSection
        onFilterChange={onFilterChange}
        control={control}
        rows={pricingServices}
        filterByRows
        onToggle={onToggleOverride || handleToggleFilterPanel}
        disableOutline={disableOutline}
      />
    </Box>
  )
}

DraftServiceFilterSidebar.propTypes = {
  onToggle: PropTypes.func,
  disableOutline: PropTypes.bool,
}

export default DraftServiceFilterSidebar
